module.exports = "query GetLeaderBoards {\n  leaderBoards {\n    ...LeaderBoardFragment\n  }\n}\n"